

import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon/index.vue' // svg component

// register globally
Vue.component('svg-icon', SvgIcon)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const req = require.context('./svg', false, /\.svg$/)
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const requireAll = (requireContext: __WebpackModuleApi.RequireContext) =>
  requireContext.keys().map(requireContext)
requireAll(req)
